import Background from "./background";

export default function ResultsPage({ children }) {
  return (
    <div className="page page--results">
      <Background />
      {children}
    </div>
  );
}
